import React from "react";
import { useSelector } from "react-redux";

import LineItem from "../../Product/LineItem";
import { useTranslation } from "react-i18next";

const CartPreview = () => {
  const { checkout } = useSelector(state => state.checkout);
  const { t } = useTranslation(["checkout"]);

  return (
    <div className="line-items">
      {checkout?.lines?.edges?.length > 0 ? (
        <>
          {checkout?.lines?.edges?.map(item => (
            <LineItem lineItem={item?.node} key={item?.node?.merchandise?.id} />
          ))}
        </>
      ) : (
        <div>{t("Your cart is empty")}</div>
      )}
    </div>
  );
};

export default CartPreview;
